
export const environment = {
  production: true,
  deploymentProd: true,
  //baseUrl:'https://onburd.herokuapp.com/api/v1',
  //baseUrl: 'https://digicomme.com:1700/api/v1'
  baseUrl: 'https://app.onburd.com/api/v1',
  //baseUrl: "https://onburdbe.azurewebsites.net/api/v1",
  frontendUrl: 'https://onburd.com',
  //baseUrl: "http://98.71.226.190:3004/api/v1",
  //hotelBaseUrl:"api",
  hotelBaseUrl:"https://api.hotelbeds.com",
  azureStorageContainerUrl: "https://onburdstorageaccount.blob.core.windows.net/onburd/public/onburd_fe/assets",
  kalabashBaseUrl:"https://kalabash-api-paasservice-test.azurewebsites.net",
  PSSMerchantCode: "32DDB0533A8C4D27A063DCB706125C7C",
  PSSMerchantCodeLive:"ON23011694",
  PSSMerchantKeyLive:"bc120623-5846-456c-a410-e9010d398a52",
  PSSLiveUrl:"https://paas.kalabash54.com",
  PSSMerchantKey: "ABF560E0-D99A-41EF-B7F7-3C219E2B9264",
  PaystackTest: "pk_test_60542cf876252561ac129f72695d3111c36ca0b3",
  PaystackLive:"pk_live_adf3fd963e052771794dea29f030495f870e4865",

  CorporateBaseUrl:"https://98.71.226.190:3006",
  PSSRate:0.25,
  mixPanelToken: "701f95d35bcfb50b70331860d95d24ee",
  ZILLA_PUBLICKEY:"PK_PROD_000d8fbe3a262ad32ae0e1270e1c032796c0069b654f125988a5e4af650a7ed6",
  ZILLA_SECRET:"SK_PROD_d5f28a87d3f3db211e75feb93e2db3be6533b8ccb6fb6b4a988899d19fb69055",

  stripeAPIKey:"pk_test_51MshPECB3RryEyLm7BLNMWVBHe7uAE1D3JtBZkwVTrwKTp6nEbsSOPTrHa86SZKoL2iDhCRQYVQmjJokFytS0XaJ00vUhGz5i3",
  wakaEventsUrl: "https://wakanow-data-api-events-production-prod.azurewebsites.net/api",
  wakaEventsImageUrl: "https://waka-events.azureedge.net",
  onburdUrl: "https://wakanow-corporate-develop-backend.azurewebsites.net/api/v1",
  wakanowAuthUrl: "https://wakanow-data-api-auth-devtest.azurewebsites.net/api/token",
  wakanowUserId: "CB18D54A8A46498797B7165EC293D38A",
  wakanowUserSecret: "!WakDaTACliCrMSecEnT",
  WAKARIDES_APP_Key: 'WAKARIDES_APP_KEY651e916261ed5',
  WAKARIDES_APP_ID: 'WAKARIDES_APP_ID651e916261ed0',
};
